<template>
    <div class="bg-White">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    
            <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top:15%">
                            <h3 class="mt-2 custom-header-title text-center text-white">Unleash Your Potential with Our <br />
Skills-Focused BootCamps</h3>
                         
                            <p class="custom-18px-500 text-center">
                                Realize Your Full Potential with Cutting-Edge Training at Our Bootcamp. Whether you're starting your career or aiming to enhance <br />
                                 your skills, our hands-on courses, led by industry experts, will propel you towards success. </p>
                            <CCol sm="12" lg="12" style="width: 60%;background-size: cover; margin: auto;color: #fff">
                                <CRow>
                                    <CCol sm="4">
                                        <h3 class="custom-28px-700">125+</h3>
                                        <p class="text-center">Course</p>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-28px-700">12+</h3>
                                        <p class="text-center">Verified Tutor</p>
                                    </CCol>
                                    <CCol sm="4">
                                        <h3 class="custom-28px-700">90k</h3>
                                        <p class="text-center">Good Reviews</p>
                                    </CCol>
                                    <CCol sm="12">
                                        <div class="text-center mb-5 mt-3">
                                        <CButton type="button" class="btn custom-button-white-bg color-blue-new"><span class="ml-4 mr-4">Contact Us</span></CButton>
                                    </div>
                        </CCol>
                                </CRow>
                            </CCol>
                            
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
        </CCol>
    
        <CCol sm="12" class="bg-white">
    
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                <CRow class="">
                    <CCol sm="12">
    
                        <h3 class="custom-32px text-left mt-4">Coming Soon</h3>
                        <CRow class="mb-2" @click="GoToTraining()">
                            <CCol sm="3"><img style="max-width:100%;border-radius:10px" src="../assets/img/Poster.png"/></CCol>
                            <CCol sm="9">
                                <h3 class="custom-32px text-left">Kuasai Sifir Tanpa Hafal Dalam 10 Minit.</h3>
                                <label class="custom-12px-500">
                                    Cikgu Ilmi
                                </label>
                                <p class="custom-sub-text">
                                    Kelas ini bertujuan untuk membantu pelajar memperoleh kecekapan dalam operasi matematik asas tanpa mengandalkan hafalan terutama didalam bab sifir, darab dan bahagi. Dalam kelas ini, teknik-teknik pengiraan pantas diajar untuk mempercepatkan proses pengiraan
                                    dan meningkatkan kefahaman terhadap konsep matematik. Dengan menyertai kelas ini, pelajar akan dapat meningkatkan kefahaman dan keyakinan mereka dalam matematik, serta memperoleh kemahiran penting yang dapat membantu mereka
                                    dalam kehidupan seharian.
                                </p>
                                <CRow>
                            <CCol sm="6">
                                <CButton class="custom-btn-light-blues color-blue-light"> Public Speaking</CButton>
                            </CCol>
                            <CCol sm="6">
                                <div class="float-right">
                                    <CButton class="custom-btn-light-blues color-blue-light"><img style="width:24px" src="../assets/img/bookmarkblue.png" /> Design</CButton>
                                    <CButton class="custom-btn-light-blues ml-2 color-blue-light"><img style="width:24px" src="../assets/img/shareblue.png" /> Share</CButton>
                                </div>
                            </CCol>
                        </CRow>
                            </CCol>
                        </CRow>
<br />
                        <hr />
                        <br />
                        <CRow class="mt-2">
                            <CCol sm="3"><img style="max-width:100%;border-radius:10px" src="../assets/img/Poster.png" /></CCol>
                            <CCol sm="9">
                                <h3 class="custom-32px text-left">Kuasai Teknik Ucapan Spontan (Public Speaking) Dalam Bahasa Melayu.</h3>
                                <label class="custom-12px-500">
                                   DJ. Ridhwan
                                </label>
                                <p class="custom-sub-text">
                                    Kelas ini dirancang untuk membantu peserta mengembangkan kemahiran berkomunikasi secara efektif dalam situasi awam. Peserta akan dipandu melalui pelbagai teknik untuk mengatasi ketakutan berucap di hadapan orang ramai, merancang dan menyusun ucapan yang padu, serta memperbaiki gaya pengucapan dan intonasi dalam Bahasa Melayu. Melalui latihan dan bimbingan yang berterusan, peserta akan memperoleh keyakinan dan kefasihan yang diperlukan untuk memberikan ucapan yang berkesan dan memukau. Kelas ini memberi penekanan pada penguasaan bahasa dan kemahiran komunikasi yang penting dalam kehidupan profesional dan sosial.
                                </p>
                                <CRow>
                            <CCol sm="6">
                                <CButton class="custom-btn-light-blues color-blue-light"> Public Speaking</CButton>
                            </CCol>
                            <CCol sm="6">
                                <div class="float-right">
                                    <CButton class="custom-btn-light-blues color-blue-light"><img style="width:24px" src="../assets/img/bookmarkblue.png" /> Design</CButton>
                                    <CButton class="custom-btn-light-blues ml-2 color-blue-light"><img style="width:24px" src="../assets/img/shareblue.png" /> Share</CButton>
                                </div>
                            </CCol>
                        </CRow>
                            </CCol>
                        </CRow>
<br /><br />
                      
    
                    </CCol>
                </CRow>
    
            </CCol>
    
            </CCol>

            <CCol sm="12" class="bg-grey">
            <CCol sm="12" lg="12">
                <div class="text-center">
                    <br /><br />
                    <CCol sm="12" style="width: 90%;background-size: cover; margin: auto;">
                        <br />
                        <CRow class="mt-5">
                            <CCol sm="12">
                                <h1 class="custom-header-title-choose text-black mt-3 p-40 text-center poppin-font text-60px">Bootcamp</h1>
                                <h3 class="mt-4 mb-4 text-black text-24px text-center p-40 custom-24px-400">This platform aims to guide users to explore subjects in depth through specific training courses or workshops, providing both theoretical knowledge and practical application opportunities.</h3>
                                <br />
                                <CInput type="text" />
    
                                <div class="border-white-radius text-black mb-4">
                                    <span class="m-2">ALL</span>
                                    <span class="m-2"><img style="max-width:100px" src="../assets/img/copywriting.png" /></span>
                                    <span class="m-2">Photo Generator</span>
                                    <span class="m-2">Coding (Beginner)</span>
                                    <span class="m-2">Coding (Intermediate)</span>
                                    <span class="m-2">Coding (Advance)</span>
                                    <span class="m-2">Programming</span>
                                </div>
    
                            </CCol>
    
                        </CRow>
                        <CRow>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t1.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t2.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t3.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t4.png" /></CCol>
    
    
                        </CRow>
                        <CRow class="mt-2 mb-2">
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t5.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t6.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t7.png" /></CCol>
                            <CCol sm="3"><img style="max-width:100%" src="../assets/img/t8.png" /></CCol>
                        </CRow>
                        <CRow>
    
                        </CRow>
    
                    </CCol>
                </div>
            </CCol>
    
        </CCol>
       
    
        <CCol sm="12" class="bg-grey">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 90%;margin: auto;">
                        <div class="text-center">
                            <br /><br /><br />
                            <h1 class="custom-text-aladdin text-black poppin-font text-48px">
                                What Our Students Say About Us.
                            </h1>
                            <br /><br /><br />
                            <CRow class="mt-4">
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-40" style="min-height:400px;border:none">
                                        <div class="text-left">
                                            <img style="max-width:30px" src="../assets/img/quote1.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-left">Menarik dan menyeronokkan</h3>
                                            <label class="text-left text-grey custom-result-grey">“Saya telah menghantar anak saya belajar di Bengkel Matematik disini. Anak saya kini lebih fokus dan cekap dalam subjek Matematik. Sesi pembelajaran juga santai dan menyeronokkan.”</label>
    
                                            <br />
                                            <span class="border-grey">
                                                <img style="max-width:40px" src="../assets/img/star1.png" /> 5.0
                                              </span>
                                            <CRow class="mt-2 mb-5">
                                                <CCol sm="3"> <img style="max-width:50px" src="../assets/img/user2.png" /></CCol>
                                                <CCol sm="9">
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Siti Munirah<br />Ibu Bapa
                                                                                            </label></CCol>
    
                                                </CCol>
                                            </CRow>
                                        </div>
    
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-40" style="min-height:500px;border:none">
                                        <div class="text-left">
                                            <img style="max-width:30px" src="../assets/img/quote1.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-left">Tingkatkan kemahiran</h3>
                                            <label class="text-left text-grey custom-result-grey">“Banyak tips yang diberikan oleh pengajar. Kursus juga padat dengan info dan sangat relevan. Dalam masa 3 hari saya dapat menguasai kemahiran programming. Sebagai seorang pemula, ini adalah kelas yang mudah difahami dan terbaik.”</label>
                                            <span class="border-grey">
                                                <img style="max-width:40px" src="../assets/img/star1.png" /> 5.0
                                              </span>
                                            <CRow class="mt-2 mb-5">
                                                <CCol sm="3"> <img style="max-width:50px" src="../assets/img/user4.png" /></CCol>
                                                <CCol sm="9">
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Rahmat M. <br />Professional
                                                                                            </label></CCol>
    
                                                </CCol>
                                            </CRow>
    
                                        </div>
    
                                    </CCard>
                                </CCol>
    
                                <CCol sm="4">
                                    <CCard class="bg-white b-20 p-40" style="min-height:500px;border:none">
                                        <div class="text-left">
                                            <img style="max-width:30px" src="../assets/img/quote1.png" class="mt-5" />
    
                                            <h3 class="poppin-font text-black text-24px text-bold mt-5 custom-text-aladdin-sub text-left">Tips dan info terbaru</h3>
                                            <label class="text-left text-grey custom-result-grey">“Pengalam dan pembelajaran yang boleh diaplikasikan dalam bisnes. Digital Marketing di sosial media sangat penting sekarang. Banyak tips dan info terkini yang diberi. Sangat berguna.”</label>
                                            <span class="border-grey">
                                                <img style="max-width:40px" src="../assets/img/star1.png" /> 5.0
                                              </span>
                                            <CRow class="mt-2 mb-5">
                                                <CCol sm="3"> <img style="max-width:50px" src="../assets/img/user5.png" /></CCol>
                                                <CCol sm="9">
                                                    <CCol sm="10"><label class="text-black text-left mt-2">Radhi Ali <br />Professional
                                                                                            </label></CCol>
    
                                                </CCol>
                                            </CRow>
    
                                        </div>
    
                                    </CCard>
                                </CCol>
    
                            </CRow>
                        </div>
    
                    </CCol>
                </div>
            </CCol>
        </CCol>

        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    
    <CCol sm="12" lg="12">
        <CRow>
            <CCol sm="12" lg="12">
                <div>
                   
                    <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff">
                        <CRow>
                            <CCol sm="6">
                              <img src="../assets/img/phonetab.png" style="max-width:100%"/>
                            </CCol>
                            <CCol sm="6">
                                <br /><br />
                                <h1 class="custom-48px-white mt-5">
                                    Download Our <br /> Mobile App
                </h1>
                <br />
                <p class="custom-16px-500 text-white">Our application can be found in the store below</p>
                <CRow class="mt-3 ml-2">
         <img style="max-width:100%" src="../assets/img/googleplay.png" class="mr-2"/>
         <img style="max-width:100%" src="../assets/img/appstore.png" />
          </CRow>
                            </CCol>
                         
                        </CRow>
                    </CCol>
                </div>
            </CCol>



        </CRow>
    </CCol>
</CCol>
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap

        };
    },
    created() {
        AOS.init();
    },
    methods:{
        GoToTraining()
        {
            this.$router.push("TrainingClass");
        }
    }

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat');
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}

.custom-tab .nav-link.active {
    border-bottom: 2px solid #000;
    /* Replace with your desired border color */
}
</style>